<template>
    <div class="card">
        <div class="card-header">
            <div class="row">
                <div class="col-md-6">
                    <h4 class="m-b-0"><i class="fas fa-file-signature"></i> Trade Overview</h4>
                </div>
                <div class="col-md-6 text-right" v-if="trade.trade_status === 'OPEN' && isAuthenticForEdit()">
                    <div class="button-group">
                        <a @click="setQuantityUnitPrice" class="btn btn-success waves-effect waves-light" data-target="#contractOverview"
                           data-toggle="modal" href="javasript:void(0);">
                            <i class="fas fa-edit"></i> Edit
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-lg-6">
                    <dl class="row mb-0">
                        <div class="col-sm-4 text-sm-right">
                            <dt>Buyer</dt>
                        </div>
                        <div class="col-sm-8 text-sm-left">
                            <dd class="mb-1"><a href="">{{trade.buyer_first_name+' '+trade.buyer_last_name}}</a></dd>
                        </div>
                    </dl>
                    <dl class="row mb-0">
                        <div class="col-sm-4 text-sm-right">
                            <dt>Seller</dt>
                        </div>
                        <div class="col-sm-8 text-sm-left">
                            <dd class="mb-1"><a href="">{{trade.seller_first_name+' '+trade.seller_last_name}}</a></dd>
                        </div>
                    </dl>
                    <dl class="row mb-0">
                        <div class="col-sm-4 text-sm-right">
                            <dt>Commodity</dt>
                        </div>
                        <div class="col-sm-8 text-sm-left">
                            <dd class="mb-1">
                                <p>{{trade.commodity_name}}</p>
                                <p>{{trade.description}}</p>
                            </dd>
                        </div>
                    </dl>
                    <dl class="row mb-0">
                        <div class="col-sm-4 text-sm-right">
                            <dt>Quantity</dt>
                        </div>
                        <div class="col-sm-8 text-sm-left">
                            <dd class="mb-1">{{trade.quantity | count}} {{trade.unit.symbol}}</dd>
                        </div>
                    </dl>
                    <dl class="row mb-0">
                        <div class="col-sm-4 text-sm-right">
                            <dt>Unit Price</dt>
                        </div>
                        <div class="col-sm-8 text-sm-left">
                            <dd class="mb-1" v-if="trade.unit_price">{{trade.unit_price | money }}</dd>
                        </div>
                    </dl>
                    <dl class="row mb-0">
                        <div class="col-sm-4 text-sm-right">
                            <dt>Total Amount</dt>
                        </div>
                        <div class="col-sm-8 text-sm-left">
                            <dd class="mb-1" v-if="trade.total_amount">{{trade.total_amount | money}}</dd>
                        </div>
                    </dl>
                    <dl class="row mb-0">
                        <div class="col-sm-4 text-sm-right">
                            <dt>Contract</dt>
                        </div>
                        <div class="col-sm-8 text-sm-left">
                            <dd class="mb-1">
                                <router-link :to="{name: 'view-marketplace-contract', params: {contractid: trade.contract_ref}}" v-if="trade.contract_ref">{{trade.contract_ref}}</router-link>
                                <span v-else>NA</span>
                            </dd>
                        </div>
                    </dl>
                </div>
                <div class="col-lg-6" id="cluster_info">
                    <dl class="row mb-0">
                        <div class="col-sm-4 text-sm-right">
                            <dt>Created</dt>
                        </div>
                        <div class="col-sm-8 text-sm-left">
                            <dd class="mb-1">{{trade.trade_created_at | date}}</dd>
                        </div>
                    </dl>
                    <dl class="row mb-0">
                        <div class="col-sm-4 text-sm-right">
                            <dt>Contract Type</dt>
                        </div>
                        <div class="col-sm-8 text-sm-left">
                            <dd class="mb-1">{{trade.contract_type | capitalize}}</dd>
                        </div>
                    </dl>
<!--                    <dl class="row mb-0">-->
<!--                        <div class="col-sm-4 text-sm-right">-->
<!--                            <dt>Maturation</dt>-->
<!--                        </div>-->
<!--                        <div class="col-sm-8 text-sm-left">-->
<!--                            <dd class="mb-1">Apr 15, 2018</dd>-->
<!--                        </div>-->
<!--                    </dl>-->
                    <dl class="row mb-0">
                        <div class="col-sm-4 text-sm-right">
                            <dt>Payment</dt>
                        </div>
                        <div class="col-sm-8 text-sm-left">
                            <dd class="mb-1">Cash Settled</dd>
                        </div>
                    </dl>
                    <dl class="row mb-0">
                        <div class="col-sm-4 text-sm-right">
                            <dt>Terms</dt>
                        </div>
                        <div class="col-sm-8 text-sm-left">
                            <dd class="mb-1">Seller agrees to ship above stated quantity to the buyer</dd>
                        </div>
                    </dl>
                    <dl class="row mb-0">
                        <div class="col-sm-4 text-sm-right">
                            <dt>Provenance</dt>
                        </div>
                        <div class="col-sm-8 text-sm-left">
                            <dd class="mb-1" v-if="trade.provenance"><a :href="trade.provenance" target="_blank">{{
                                trade.provenance }}</a></dd>
                            <dd class="mb-1" v-else>NA</dd>
                        </div>
                    </dl>
                    <dl class="row mb-0">
                        <div class="col-sm-4 text-sm-right">
                            <dt>Audit</dt>
                        </div>
                        <div class="col-sm-8 text-sm-left">
                            <dd class="mb-1" v-if="trade.audit"><a :href="trade.audit" target="_blank">{{
                                trade.audit }}</a></dd>
                            <dd class="mb-1" v-else>NA</dd>
                        </div>
                    </dl>
                </div>
            </div>
        </div>

        <div aria-labelledby="contractOverview" class="modal fade" id="contractOverview" role="dialog" tabindex="-1">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-body card-blue">
                        <div class="card-body">
                            <h4 class="card-title">Update Trade</h4>
                            <h5 class="card-subtitle">Change trade quantity and unit price</h5>
                            <!-- Tab panes -->
                            <div class="tab-content">
                                <div class="tab-pane active" id="properties" role="tabpanel">
                                    <div class="row m-t-20">
                                        <div class="col-md-12">
                                            <form>
                                                <div class="col-sm-12 col-lg-12 m-t-20">
                                                    <div class="form-group row">
                                                        <label class="text-right col-sm-2 control-label col-form-label">Quantity</label>
                                                        <div class="input-group col-sm-8">
                                                            <input class="form-control"
                                                                   data-vv-as="Provenance"
                                                                   name="provenance"
                                                                   placeholder="Trade Quantity"
                                                                   style="width: calc(100% - 70px); height: 42px;"
                                                                   type="text"
                                                                   v-model="update_trade.quantity"
                                                                   v-validate="">
                                                            <input :value="trade.unit.symbol" class="form-control"
                                                                   disabled>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-12 col-lg-12 m-t-20">
                                                    <div class="form-group row">
                                                        <label class="text-right col-sm-2 control-label col-form-label">Unit
                                                            Price</label>
                                                        <div class="input-group col-sm-8">
                                                            <input class="form-control"
                                                                   data-vv-as="Provenance"
                                                                   name="provenance"
                                                                   placeholder="Unit Price"
                                                                   style="width: calc(100% - 80px); height: 42px;"
                                                                   type="text"
                                                                   v-model="update_trade.unit_price"
                                                                   v-validate="">
                                                            <input :value="trade.unit_price.currency_symbol+'/'+trade.unit.symbol"
                                                                   class="form-control"
                                                                   disabled>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-12 col-lg-12 m-t-20">
                                                    <div class="form-group row">
                                                        <label class="text-right col-sm-2 control-label col-form-label">Trade Amount</label>
                                                        <div class="input-group col-sm-8">
                                                            <input class="form-control"
                                                                   data-vv-as="Provenance"
                                                                   name="provenance"
                                                                   placeholder="Trade Quantity"
                                                                   style="height: 42px;"
                                                                   type="text"
                                                                   readonly
                                                                   :value="trade.unit_price.currency_symbol+ ' '+ update_trade.quantity*update_trade.unit_price"
                                                                   v-validate="">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-12 col-lg-12 m-t-20">
                                                    <div class="form-group row">
                                                        <label class="text-right col-sm-2 control-label col-form-label">Provenance</label>
                                                        <div class="input-group col-sm-8">
                                                            <input class="form-control"
                                                                   data-vv-as="Provenance"
                                                                   name="provenance"
                                                                   placeholder="Provenance"
                                                                   style="height: 42px;"
                                                                   type="text"
                                                                   v-model="update_trade.provenance"
                                                                   v-validate="">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-12 col-lg-12 m-t-20">
                                                    <div class="form-group row">
                                                        <label class="text-right col-sm-2 control-label col-form-label">Audit</label>
                                                        <div class="input-group col-sm-8">
                                                            <input class="form-control"
                                                                   data-vv-as="Audit"
                                                                   name="audit"
                                                                   placeholder="Audit"
                                                                   style="height: 42px;"
                                                                   type="text"
                                                                   v-model="update_trade.audit"
                                                                   v-validate="">
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="update" class="btn waves-effect waves-light btn-success" data-dismiss="modal"
                                type="submit">Submit
                        </button>
                        <button @click="reset" class="btn waves-effect waves-light btn-secondary" type="button">Reset</button>
                        <button class="btn waves-effect waves-light btn-danger" data-dismiss="modal" type="button">
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import returns from "@/components/protected/marketplace/inventory/Returns.vue";
    import {mapGetters} from "vuex";

    export default {
        name: "TradeDocuments",
        props: {
            tradeid: String,
            trade: Object,
            events: Object
        },
      computed: {
        ...mapGetters(["currentUser"])
      },
        data() {
            return {
                steps: {
                    forward: [
                        {status: "OPEN", icon: "far fa-folder-open fa-lg"},
                        {status: "ACCEPTED", icon: "far fa-handshake fa-lg"},
                        {status: "SIGNED", icon: "fas fa-pencil-alt fa-lg"},
                        {status: "ESCROWED", icon: "fab fa-ethereum fa-lg"},
                        {status: "SCHEDULED", icon: "far fa-calendar-alt fa-lg"},
                        {status: "SHIPPED", icon: "fas fa-truck fa-lg"},
                        {status: "RELEASED", icon: "far fa-money-bill-alt fa-lg"},
                        {status: "COMPLETE", icon: "far fa-smile fa-lg"}
                    ],
                    spot: [
                        {status: "OPEN", icon: "far fa-folder-open fa-lg"},
                        {status: "ACCEPTED", icon: "far fa-handshake fa-lg"},
                        {status: "SIGNED", icon: "fas fa-pencil-alt fa-lg"},
                        {status: "PAYMENT", icon: "fab fa-ethereum fa-lg"},
                        {status: "SCHEDULED", icon: "far fa-calendar-alt fa-lg"},
                        {status: "SHIPPED", icon: "fas fa-truck fa-lg"},
                        {status: "COMPLETE", icon: "far fa-smile fa-lg"}
                    ]
                },
                update_trade: {
                    unit_id: null,
                    quantity: null,
                    unit_price: null,
                    provenance: null,
                    audit: null
                }
            }
        },
        methods: {
            setQuantityUnitPrice(){
                if(this.trade){
                    this.update_trade.quantity = Number(this.trade.quantity).toFixed(2);
                    this.update_trade.unit_price = this.trade.unit_price.amount;
                    this.update_trade.provenance = this.trade.provenance;
                    this.update_trade.audit = this.trade.audit;
                }
            },
            async update() {
                if(this.trade){
                    try {
                        this.update_trade.unit_id = this.trade.unit.id;
                        await this.$http.put(`/trades/${this.trade.trade_id}`, this.update_trade);
                        await this.$parent.getTrade();
                    } catch (e) {

                    }
                }
            },
            reset(){
                this.update_trade = {
                    unit_id: null,
                    quantity: null,
                    unit_price: null
                }
            },
            isAuthenticForEdit() {
              return (this.trade && this.trade.type === 'BUY' && this.trade.buyer_id === this.currentUser.id) ||
                      (this.trade && this.trade.type === 'SELL' && this.trade.seller_id === this.currentUser.id)
            }
        }
    }
</script>

<style scoped>
    .stepwizard-step p {
        margin-top: 10px;
    }

    .stepwizard-row {
        display: table-row;
    }

    .stepwizard {
        display: table;
        width: 100%;
        position: relative;
    }

    .stepwizard-step button[disabled] {
        opacity: 1 !important;
        filter: alpha(opacity=100) !important;
    }

    .stepwizard-row:before {
        top: 14px;
        bottom: 0;
        position: absolute;
        content: " ";
        width: 100%;
        height: 1px;
        background-color: #ccc;
        z-order: 0;
    }

    .stepwizard-step {
        display: table-cell;
        text-align: center;
        position: relative;
    }

    .btn-circle {
        width: 30px;
        height: 30px;
        text-align: center;
        padding: 6px 0;
        font-size: 12px;
        line-height: 1.428571429;
        border-radius: 15px;
    }
</style>
